export default __webpack_public_path__ + "static/media/thumbnail-m-cushion.023c449f.png";